// @flow
import clamp from 'lodash/fp/clamp';
import prop from 'lodash/fp/prop';
import includes from 'lodash/fp/includes';
import compose from 'lodash/fp/compose';
import reduce from 'lodash/fp/reduce';
import head from 'lodash/fp/head';
import { find } from 'lodash';

import { nextRoutes } from '@i18n';

export const humanize = (str: Array<string>): string =>
  str
    .join(' ')
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/^[a-z]/, m => m.toUpperCase());

export const findAndGetUrl = (routeIdentifier: string, params: {} = {}): string => {
  const { locale } = nextRoutes;
  return nextRoutes.findAndGetUrls(routeIdentifier, locale, params).urls.as;
};

export const getQuotientRange = (min: number, max: number, quotient: number) => {
  const quotientRange = (quotient - min) / (max - min);
  return clamp(0, 1, quotientRange);
};

export const getWindowHeight = () => (typeof window === 'undefined' ? 0 : window.innerHeight);

export const getCityFromGooglePlacesResults = compose(
  reduce((accu, { types, long_name }) => (includes('locality', types) ? long_name : accu), ''),
  prop('address_components'),
  head
);

export const getPostcodeFromGooglePlacesResults = (
  results: Array<{
    address_components: Array<{ types: Array<string>, long_name: string }>,
    geometry: { location: {} }
  }>
): Promise<string> =>
  new Promise((resolve, reject) => {
    if (!window.google.maps || !window.google.maps.Geocoder || !results) return;

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ location: results[0].geometry.location }, (results, status) => {
      if (status !== window.google.maps.GeocoderStatus.OK) return reject();

      const postcode: ?string = find(
        results[0].address_components,
        ({ types }: { types: Array<string> }): boolean => types.includes('postal_code')
      )?.long_name;

      if (!postcode) return reject();
      return resolve(postcode);
    });
  });

export const isUserAgentMobile = (req: any): boolean => {
  const isServer = !!req;

  if (isServer) {
    return /iPhone|iPad|iPod|Android/i.test(req.headers['user-agent']);
  }

  return /iPhone|iPad|iPod|Android/i.test(navigator?.userAgent);
};

export const calculateGridUnitSize = (length: number, onScreenCount: number) =>
  Math.ceil(length / onScreenCount) * onScreenCount;

export const sortQueryParams = (query: any, sequence: Array<string>) => {
  const sortedQuery = {};
  sequence.forEach((key) => {
    // eslint-disable-next-line no-prototype-builtins
    if (query.hasOwnProperty(key)) {
      sortedQuery[key] = query[key];
    }
  });
  Object.keys(query).forEach((key) => {
    // eslint-disable-next-line no-prototype-builtins
    if (!sortedQuery.hasOwnProperty(key)) {
      sortedQuery[key] = query[key];
    }
  });
  return sortedQuery;
};
